import {NgModule} from '@angular/core';
import {ConfigurationService} from './configuration.service';
import {DebugService} from './debug.service';

@NgModule({
   imports: [],
   declarations: [],
   providers: [
      ConfigurationService,
      DebugService,
   ]
})
export class ConfigurationModule {
}



// WEBPACK FOOTER //
// ./src/app/configuration/configuration.module.ts